import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaFallback from './VaFallback.vue'

export const VaFallback = withConfigTransport(_VaFallback)
